import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import GuiaRapido from "@/pages/GuiaRapido";
import Login from "@/pages/Login";
import Cadastro from "@/pages/Cadastro";
import EsqueciSenha from "@/pages/EsqueciSenha";
import RedefinirSenha from "@/pages/RedefinirSenha";
import Dashboard from "@/pages/Dashboard";
import Aquecimento from "@/pages/Aquecimento";
import Frases from "@/pages/Frases";
import Planos from "@/pages/Planos";
import PagamentoConcluido from "@/pages/PagamentoConcluido";
import MinhaConta from "@/pages/MinhaConta";
import Termos from "@/pages/Termos";
import Privacidade from "@/pages/Privacidade";
import Admin from "@/pages/Admin";
import FunilConversao from "@/pages/FunilConversao";
import { Flame } from "lucide-react";

function FullScreenLoader() {
  return (
    <div className="min-h-screen bg-[#090D16] flex items-center justify-center">
      <Flame className="w-10 h-10 text-emerald-400 animate-pulse" />
    </div>
  );
}

function Protected({ children, admin = false, requiresPlan = false }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (requiresPlan && user.role !== "admin" && !["premium", "grace"].includes(user.subscription_status)) {
    return <Navigate to="/planos" replace state={{ locked: true }} />;
  }
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<PublicOnly><Landing /></PublicOnly>} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/cadastro" element={<PublicOnly><Cadastro /></PublicOnly>} />
            <Route path="/esqueci-senha" element={<PublicOnly><EsqueciSenha /></PublicOnly>} />
            <Route path="/redefinir-senha" element={<PublicOnly><RedefinirSenha /></PublicOnly>} />
            <Route path="/termos" element={<Termos />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/dashboard" element={<Protected requiresPlan><Dashboard /></Protected>} />
              <Route path="/guia" element={<GuiaRapido />} />
              <Route path="/aquecimento" element={<Protected requiresPlan><Aquecimento /></Protected>} />
              <Route path="/frases" element={<Protected admin><Frases /></Protected>} />
              <Route path="/planos" element={<Planos />} />
              <Route path="/pagamento-concluido" element={<PagamentoConcluido />} />
              <Route path="/conta" element={<MinhaConta />} />
              <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="/admin/funil" element={<Protected admin><FunilConversao /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
